export class UserActionCommon {

    public static getConfigPathFromKey(configKey: string): string {
        return `settings/${configKey}/Config.json`
    }

}
